<template>
	<div class="institution-selector">
		<VaSelect
			style="width: 650px"
			v-model="selectedInstitution"
			placeholder="Seleccione una institución"
			inner-label
			:options="institutions"
			text-by="name"
			value-by="id"
			color="#000000"
			no-options-text="No se encontraron elementos" />
	</div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { RootState } from '@/store/types'

const store = useStore<RootState>()
const selectedInstitution = ref(store.getters['global/currentInstitution'])

const institutions = computed(() => {
	const instObj = store.state.global.institutions
	return Object.entries(instObj).map(([id, name]) => ({
		id,
		name
	}))
})

watch(selectedInstitution, async newValue => {
	await store.dispatch('global/changeInstitution', newValue)
})

watch(
	() => store.getters['global/currentInstitution'],
	newValue => {
		selectedInstitution.value = newValue
	}
)
</script>

<style scoped>
.institution-selector {
	margin-right: 1rem;
}

/* Test mode styles */
:deep(.test-mode) .institution-select {
	background-color: #dc3545;
	color: white;
	border-color: #dc3545;
}

:deep(.test-mode) .institution-select:hover {
	border-color: #ffcdd2;
}

:deep(.test-mode) .institution-select option {
	background-color: #dc3545;
	color: white;
}
</style>
